module.exports = __webpack_public_path__ + "fonts/TildaSans-ExtraBold.5f6f13b.ttf";